<template>
  <div id="main-container-hot">
    <HeaderHotSite />
    <div id="main-container">
      <div id="landing-intro-container">
          <img src="./logo_pamcard_branco 1.svg" alt="logo">
        <a @click="scrollToFooter" class="link-to">
          <button>
            Quero a minha
            <img src="./setaBotao.svg" />
          </button>
        </a>
        <h2 class="pamMessage">
          TAG do caminhoneiro. Uma iniciativa do <span>Pamcard</span> e da <span>Move Mais</span> para viabilizar o único plano de TAG sem taxa de adesão, sem mensalidade, sem vínculo de cartão de crédito.
        </h2>
        <p class="pamMessage">Confira as vantagens de ter a <span>TAG do Caminhoneiro</span></p>
      </div>
    </div>
  </div>
</template>

<style lang="css" scoped>
  .pamMessage{
    margin-top: 20px;
    font-size: 30px;
    color: #ffffff;
  }
  .pamMessage span{
    color: #ffce00;
  }
.pamMessage h2 {
  font-size: 34px;
}

#main-container {
  width: 100vw;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.link-to{
  width: 42rem;
}

#landing-intro-container {
  width: 70vw;
  margin-top: 12px;
  display: flex;
  flex-direction: column;
}
#landing-intro-container button {
  background-color: #ffce00;
  color: #5d3b81;
  border: none;
  border-radius: 55px;
  padding: 2rem 4rem;
  font-size: 4rem;
  margin: 3rem 0;
}
#landing-intro-container button img {
  width: 5rem;
}
#landing-intro-container h1 {
  color: #ffffff;
  font-size: 11rem;
}

#landing-intro-container h1 span {
  color: #ffce00;
}
#landing-intro-container h2 {
  color: #ffffff;
}
#landing-intro-container h2 span {
  color: #ffce00;
}

#main-container-hot {
  margin-top: 39px;
  display: flex;
  flex-direction: column;
  background-image: url("./bg_hotsite.svg");
  width: 100vw;
  height: 100vh;
  background-size: cover;
  background-repeat: no-repeat;
  aspect-ratio: 1 / 1;
}

@media (max-width: 600px) {
  #landing-intro-container {
    width: 70vw;
  }
  #landing-intro-container button {
    background-color: #ffce00;
    color: #5d3b81;
    border: none;
    border-radius: 55px;
    padding: 2px;
    font-size: 2rem;
    width: 23rem;
    margin: 3rem 0;
  }
  #landing-intro-container h1 {
    font-size: 3rem;
  }
  #landing-intro-container h2 {
    font-size: 12px;
    width: 32rem;
  }
  #main-container-hot {
    display: flex;
    background-image: url("./bg_hotsite.svg");
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    width: 100%;
    height: fit-content;
    aspect-ratio: 1 / 1;
  }
  .pamMessage{
    margin-top: -3px;
    width: 39rem;
    font-size: 12px;
    margin-left: -5rem;
    color: #ffffff;
  }
  .pamMessage span{
    color: #ffce00;;
  }
}
</style>
<script>
import VueScrollTo from "vue-scrollto";

export default {
  data() {
    return {
      roadCardPJ: config.roadCardPJ,
      showModal: false, // Variável para controlar a visibilidade do modal
    };
  },

  directives: {
    scrollTo: VueScrollTo.directive,
  },
  methods: {
    scrollToFooter() {
      VueScrollTo.scrollTo("#planInfoContainer", 500); // 500 é a duração da animação em milissegundos
    },
  },
};
</script>



// WEBPACK FOOTER //
// mainContent.vue?0eca9620